import { ColumnsType, ExternalLink } from '@agro-club/agroclub-shared'
import { DocIndex } from 'modules/docIndex/types'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ConnectedObjectCell } from './ConnectedObjectCell'
import { TruncatedValue } from 'views/components/TruncatedValue/TruncatedValue'
import { CellRenders } from 'views/components/Table/renderers'

export const useColumns = (): ColumnsType<DocIndex> => {
  const { t } = useTranslation('documents')
  return useMemo(
    () => [
      {
        title: t('file'),
        width: 140,
        dataIndex: 'uploaded_file',
        render: (file) => (
          <ExternalLink href={file.uploaded_file} target="_blank">
            <TruncatedValue hint={file.original_filename}>{file.original_filename}</TruncatedValue>
          </ExternalLink>
        ),
      },
      {
        title: t('content_type_model'),
        width: 170,
        dataIndex: 'content_type_model',
      },
      {
        title: t('document_type'),
        width: 170,
        dataIndex: 'document_type_display',
      },
      {
        title: t('connectedObject'),
        width: 140,
        dataIndex: 'id',
        render: (id: number, docIndex) => <ConnectedObjectCell docIndex={docIndex} />,
      },
      {
        title: t('created'),
        width: 140,
        dataIndex: 'created',
        render: CellRenders.date,
      },
      /*       {
        title: t('test'),
        width: 140,
        dataIndex: 'search_content',
      }, */
    ],
    [t],
  )
}
